module.exports = {
  'bad': { value: 'enum.condition.bad', code: 'B' },
  'satisfactory': { value: 'enum.condition.satisfactory', code: 'S' },
  'good': { value: 'enum.condition.good', code: 'G' },
  'very_good': { value: 'enum.condition.veryGood', code: 'VG' },
  'new': { value: 'enum.condition.new', code: 'N' }
}
